'use strict';

module.exports = Object.freeze([
  ...require('./GDPR_consents'),
  ...require('./CCPA_consents'),
]);
